import dynamic from 'next/dynamic';
import type { FC, HTMLAttributes } from 'react';
import type { LogoProps } from './types';
import { LogoWrapper } from './ThirdPartyLogo.styles';
import { logoMap } from './map';

type Props = {
  name: string;
  grayScale?: boolean;
} & Pick<LogoProps, 'withoutPadding'> &
  Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

/** Dynamically loads a third party logo. */
export const ThirdPartyLogo = ({
  name,
  withoutPadding = false,
  grayScale = false,
  className,
}: Props) => {
  const logoComponent = logoMap[name.toLowerCase()];
  if (!logoComponent) {
    return null;
  }

  const LogoComponent = dynamic(async () => {
    try {
      const module = await import(`./assets/${logoComponent}`);
      return module.default;
    } catch {
      return null;
    }
  }) as FC<LogoProps> | null;

  if (!LogoComponent) {
    return null;
  }

  return (
    <LogoWrapper grayScale={grayScale} className={className}>
      <LogoComponent withoutPadding={withoutPadding} />
    </LogoWrapper>
  );
};
